/**
 * 읽어 주기 음성 — Bench 이식.
 * 출처: picnic-bench apps/bench-web/src/shared/speak.ts @62f4f03 (canSpeak · speak).
 *
 * 브라우저 음성 합성을 그대로 쓴다. <b>소리를 못 내도 수업은 계속된다</b> — 예외를 올리지 않고,
 * 말할 수 없는 브라우저에서는 버튼 자체를 두지 않는다(눌러도 안 되는 버튼은 고장으로 읽힌다).
 *
 * Field 차이: `onEnd` 선택 인자 — 읽어 주기 버튼이 '그만 읽기' 상태를 되돌리는 데 쓴다(Bench 에는 없음).
 */

/** 이 브라우저가 말할 수 있는가. 없으면 버튼 자체를 두지 않는다. */
export function canSpeak(): boolean {
  return typeof window !== "undefined" && "speechSynthesis" in window;
}

/**
 * 한 줄을 읽는다. <b>앞의 말은 끊는다</b>. 초1 기준으로 조금 느리게(rate 0.9).
 * @param text 읽을 말. 비면 아무 일도 하지 않는다
 */
export function speak(text: string, lang = "ko-KR", opts: { onEnd?: () => void } = {}): void {
  if (!canSpeak() || !text.trim()) return;
  try {
    const synth = window.speechSynthesis;
    synth.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = lang;
    u.rate = 0.9;
    if (opts.onEnd) {
      u.onend = opts.onEnd;
      u.onerror = opts.onEnd;
    }
    synth.speak(u);
  } catch {
    /* 못 읽어도 화면은 그대로 — 글자는 눈으로도 읽을 수 있다 */
    opts.onEnd?.();
  }
}

/** 읽던 말을 멈춘다(예외 없음). */
export function stopSpeaking(): void {
  if (!canSpeak()) return;
  try {
    window.speechSynthesis.cancel();
  } catch {
    /* 무시 */
  }
}
